var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.457 11.092 5.557 2.747v4.468l-5.557-2.925z",
    fill: "#6483c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.2 18.613-5.926-3.12v-4.693l5.926 2.924zm-5.558-3.343 5.188 2.73v-4.047l-5.188-2.564z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.371 13.839v4.468l4.944-2.493v-4.46z",
    fill: "#6483c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.186 18.607v-4.882l5.313-2.67v4.873zm.369-4.655v4.055l4.575-2.307v-4.047z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m10.703 10.797 5.483 2.783 4.896-2.516-5.305-2.675z",
    fill: "#6483c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16.187 13.788-5.9-3 5.5-2.608 5.709 2.879zm-5.065-2.988 5.064 2.57 4.49-2.308-4.9-2.471z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m18.957 15.829 5.558 2.746v4.468l-5.558-2.925z",
    fill: "#952781"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7 23.349-5.926-3.12v-4.7l5.926 2.931zm-5.557-3.343 5.188 2.731v-4.048l-5.188-2.564z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m24.871 18.575v4.468l4.944-2.493v-4.46z",
    fill: "#952781"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m24.687 23.343v-4.882l5.313-2.67v4.873zm.369-4.655v4.055l4.575-2.308v-4.046z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m19.203 15.546 5.484 2.783 4.896-2.517-5.219-2.466z",
    fill: "#952781"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m24.687 18.536-5.92-3.005 5.6-2.387 5.633 2.661zm-5.047-2.976 5.046 2.561 4.479-2.3-4.806-2.27z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m2.19 15.496 5.558 2.747v4.468l-5.558-2.925z",
    fill: "#d87b30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m7.932 23.017-5.926-3.117v-4.7l5.926 2.929zm-5.557-3.343 5.188 2.731v-4.048l-5.188-2.564z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m8.104 18.243v4.468l4.944-2.493v-4.46z",
    fill: "#d87b30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m7.92 23.011v-4.882l5.313-2.67v4.873zm.369-4.655v4.055l4.575-2.311v-4.043z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m2.436 15.213 5.484 2.784 4.896-2.517-5.219-2.466z",
    fill: "#d87b30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m7.92 18.2-5.92-3 5.6-2.387 5.632 2.661zm-5.047-2.972 5.046 2.561 4.479-2.3-4.806-2.27z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m10.875 16.296 5.557 2.746v4.469l-5.557-2.926z",
    fill: "#e0d400"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m16.617 23.816-5.926-3.116v-4.7l5.926 2.929zm-5.557-3.342 5.188 2.731v-4.048l-5.188-2.564z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m16.789 19.042v4.469l4.944-2.494v-4.46z",
    fill: "#e0d400"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m16.6 23.811v-4.882l5.313-2.67v4.873zm.369-4.655v4.055l4.58-2.311v-4.043z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m11.121 16.001 5.484 2.783 4.896-2.517-5.305-2.674z",
    fill: "#e0d400"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m16.605 18.991-5.9-3 5.5-2.608 5.709 2.879zm-5.065-2.985 5.064 2.57 4.49-2.308-4.9-2.471z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVba);
export default __webpack_public_path__ + "static/media/ICON-vba.050105cb16f4f44df38a73ec2b3590fd.svg";
export { ForwardRef as ReactComponent };